import m from "mithril";
import toast from "../js/toaster";

const ForgotPassword = {
    email: "",
    isLoading: false,
    message: "",
    error: "",

    async onsubmit(e) {
        e.preventDefault();
        if (!this.email) {
            this.error = "Email harus diisi";
            return;
        }

        this.isLoading = true;
        this.error = "";
        this.message = "";
        m.redraw();

        try {
            const res = await fetch('/api/secure-auth/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: this.email })
            });

            const data = await res.json();

            if (res.ok && data.success) {
                this.message = data.message;
                toast.success(data.message);
            } else {
                this.error = data.error || "Gagal memproses permintaan";
                toast.error(this.error);
            }
        } catch (error) {
            console.error('Forgot password error:', error);
            this.error = "Terjadi kesalahan koneksi";
            toast.error(this.error);
        } finally {
            this.isLoading = false;
            m.redraw();
        }
    },

    view() {
        const isDarkMode = document.documentElement.classList.contains('dark');

        return m("div", { class: "min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4" }, [
            m("div", { class: "max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 space-y-6" }, [
                m("div", { class: "text-center" }, [
                    m("div", { class: "mx-auto bg-orange-100 dark:bg-orange-900/30 w-16 h-16 rounded-full flex items-center justify-center mb-4" }, [
                        m("i", { class: "ri-lock-unlock-line text-3xl text-orange-600 dark:text-orange-400" })
                    ]),
                    m("h2", { class: "text-2xl font-bold text-gray-900 dark:text-white" }, "Lupa Password"),
                    m("p", { class: "text-gray-600 dark:text-gray-400 mt-2" }, "Masukkan email Anda untuk menerima tautan pengaturan ulang password.")
                ]),

                this.error ? m("div", { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 text-red-700 dark:text-red-300 text-sm flex items-center" }, [
                    m("i", { class: "ri-error-warning-line mr-2" }),
                    this.error
                ]) : null,

                this.message ? m("div", { class: "bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-3 text-green-700 dark:text-green-300 text-sm flex items-center" }, [
                    m("i", { class: "ri-checkbox-circle-line mr-2" }),
                    this.message
                ]) : null,

                m("form", { onsubmit: (e) => this.onsubmit(e) }, [
                    m("div", [
                        m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Alamat Email"),
                        m("input", {
                            type: "email",
                            placeholder: "nama@example.com",
                            class: "block w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-orange-500 focus:outline-none transition-colors duration-200",
                            value: this.email,
                            oninput: (e) => { this.email = e.target.value; },
                            disabled: this.isLoading,
                            required: true
                        })
                    ]),

                    m("button", {
                        type: "submit",
                        class: "w-full mt-6 flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 transition-all duration-200",
                        disabled: this.isLoading
                    }, [
                        this.isLoading ? m("i", { class: "ri-loader-4-line animate-spin mr-2" }) : null,
                        "Kirim Tautan Reset"
                    ]),

                    m("div", { class: "mt-6 text-center" }, [
                        m("a", {
                            href: "/login",
                            oncreate: m.route.link,
                            class: "text-sm font-medium text-gray-600 hover:text-orange-600 dark:text-gray-400 dark:hover:text-orange-400 transition-colors duration-200"
                        }, [
                            m("i", { class: "ri-arrow-left-line mr-1" }),
                            "Kembali ke Halaman Masuk"
                        ])
                    ])
                ])
            ])
        ]);
    }
};

export default ForgotPassword;
